import { I as IconWrapper, _ as _objectSpread2 } from '../../dist/Icon-3ba184f8.esm.js';
import 'react';
import { jsx, jsxs } from 'react/jsx-runtime';
import 'styled-components';
import '@lendi-ui/color';

function SvgLendiBot(props) {
  return /*#__PURE__*/jsx(IconWrapper, _objectSpread2(_objectSpread2({}, props), {}, {
    children: /*#__PURE__*/jsx("svg", {
      viewBox: "0 0 20 20",
      xmlns: "http://www.w3.org/2000/svg",
      children: /*#__PURE__*/jsxs("g", {
        fill: "none",
        fillRule: "evenodd",
        children: [/*#__PURE__*/jsx("path", {
          fill: "#00C0A5",
          d: "M0 0h20v20H0z"
        }), /*#__PURE__*/jsx("path", {
          className: "lendi-bot_svg__fillPath",
          d: "M10.655 4.173l4.887 3.241c.286.19.458.509.458.85v6.38c0 .565-.463 1.023-1.034 1.023H5.034c-.571 0-1.034-.458-1.034-1.024V8.264c0-.346.177-.67.471-.858l5.047-3.241c.346-.223.794-.22 1.137.008zm3.278 9.447V8.81L10.07 6.25 6.067 8.82v4.8h2.9v-2.978h2.067v2.978h2.899z",
          fill: "#FFF"
        })]
      })
    })
  }));
}

export { SvgLendiBot as default };
